import React, { useState } from "react";
import axios from "axios";
import { height } from "@mui/system";

export default function Container() {
  const [formData, setFormData] = useState({
    diff: "",
    count: "",
    type: "",
  });


  const [text, setText] = useState("");
  const [questions, setQuestions] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [questionType, setQuestionType] = useState("multiple_choice");
  const [counts, setQuestionCount] = useState("3");
  const [difficulty, setDifficulty] = useState("medium");
  const API_KEY = "sk-proj-R3UhXQyRDv8Qm5N2mhZnT3BlbkFJkdD77FnScN3z0ptKmfz1";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default page reload
    console.log(formData.count);
    console.log(formData.diff);
    console.log(formData.type);
    setDifficulty(formData.diff);
    setQuestionCount(formData.count);
    setQuestionType(formData.type);
  //  setText(formData.text);
    generateQuestions(formData.count,formData.type);
};

const generateQuestions = async (q,t) => {
    if (!text.trim()) {
      setError("Please enter a sample text.");
      return;
    }
 //   const text = "natalie let's talk about our favorite things sure first what is your favorite color my favorite color is purple really my favorite color is purple too oh really yeah but i don't have purple clothing i love the color purple but i don't have purple clothes oh well everything i wear is purple no kidding yeah really that's so cool so what about food what's your favorite food hmm good question my favorite food is pizza i love pizza but i don't like really big pizzas i love pizza too what is your favorite topping on pizza i like really spicy toppings so salami or pepperoni uh chilies and sometimes bell peppers too do you like thick pizza or thin pizza no i don't like thick pizza because i can't eat too much but the thin pizzas i get lots of toppings and i don't feel so full uh yeah i agree what about seasons what is your favorite season my favorite season is winter winter yeah i love winter don't you no i hate winter why do you like winter i love the snow oh i hate the snow well i like the snow a little bit but i hate cold weather yeah i guess the cold is kind of annoying but the snow is so much fun i go skiing and i play snowball fights and i build snowmen yeah that sounds fun what about sports what's your favorite sport i'd say my favorite sport is tennis that's interesting do you play tennis yeah but i'm not very good do you like singles or doubles at the moment i'm having singles lessons they're really fun oh now you are taking tennis lessons yes about twice a week do you watch tennis on tv yes i watch it all the time who is your favorite tennis player hmm i really like roger federer yeah he's really good okay last question what is your favorite movie um i don't have a favorite movie but i really like comedies so what is your favorite comedy my favorite comedy is aceventura ace ventura is very funny but that movie is really old it is but it's a classic todd it's like 20 years old i think maybe more i know i've seen it a hundred times yeah i like it a lot too"
   setError("");
   setQuestions("");
    setLoading(true);
    console.log(q);
    var qus = "";
    var type = "";
    if(t == 'multiple_choice'){
        type = "multiple-choice";
    qus = `[
                    {
                       "question": "Your question here",
                        "options": {
                            "A": "Option A",
                            "B": "Option B",
                            "C": "Option C",
                            "D": "Option D"
                        },
                        "answer": "Correct option letter (A, B, C, or D)"
                    },
                    {
                       "question": "Your question here",
                        "options": {
                            "A": "Option A",
                            "B": "Option B",
                            "C": "Option C",
                            "D": "Option D"
                        },
                        "answer": "Correct option letter (A, B, C, or D)"
                    }
        ]`;
    }else if(t == 'true_false'){
        type = "True/False";
        qus = `[
                        {
                            "question": "Your question here",
                        "options": {
                            "A": "True",
                            "B": "False"
                        },
                        "answer": "Correct option letter (A or B)"
                        },
                        {
                            "question": "Your question here",
                            "options": {
                                "A": "True",
                                "B": "False"
                            },
                            "answer": "Correct option letter (A or B)"
                        }
                        ]`;
        }else if(t == 'short_answer'){
            type = "fill in the blank";
            qus = `[
                        {
                            "question": "The classic film "Gone with the _____________" is based on the novel by Margaret Mitchell.",
                            "answer": {
                                "A": "Wind"
                            }
                        },
                        {
                            "question": "In the movie "Forrest Gump," Forrest's mother famously says, "Life is like a box of _____________.",
                            "answer": {
                                "A": "Chocolates"
                            }
                        }
                ]`;
            }
    try {  
        const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
            model: "gpt-4",
            messages: [
                { 
                  role: "system", 
                  content: `You are an AI that generates ${type} questions from a given text. The difficulty level is ${difficulty} Format each question as a JSON object.` 
                },
                { 
                  role: "user", 
                  content: `Generate ${q} ${type} questions from the following text:\n\n"${text}"\n\nFormat:\n${qus}`
                }
              ],
            max_tokens: 300,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_KEY}`,
          },
        }
      );
    
      const generatedText = response.data.choices[0].message.content;
      console.log(generatedText);
      
      if (generatedText.startsWith("[")) {
        setQuestions(JSON.parse(generatedText));  // Direct parsing for correct JSON arrays
      } else {
        setError("Invalid response format from AI. Please check the API response.");
        console.error("Unexpected API Response:", generatedText);
      }

    } catch (err) {
      setError("Failed to generate questions. change question count  try again.");
      console.error("API Error:", err);
    }

    setLoading(false);
  };
  

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-6">{questions.length > 0 ? (
          questions.map((q, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <p className="font-bold">{q.question}</p>
              {questionType === "multiple_choice" && (
                <>
                <ul>
                  <li>A: {q.options.A}</li>
                  <li>B: {q.options.B}</li>
                  <li>C: {q.options.C}</li>
                  <li>D: {q.options.D}</li>
                </ul>
                 <p className="text-green-600">Answer: {q.answer}</p>
                </>
              )}
              {questionType === "true_false" && (
                <>
                <ul>
                  <li>{q.options.A}</li>
                  <li>{q.options.B}</li>
                </ul>
                <p className="text-green-600">Answer: {q.answer}</p>
                </>
              )}
              {questionType === "short_answer" && (
                <p className="text-green-600">Answer: {q.answer.A}</p>
              )}
            </div>
          ))
        ) : (
          <p>No questions generated yet.</p>
        )}</div>
        <div className="col-6">
        <form onSubmit={handleSubmit}>
          <label htmlFor="">Difficulty</label>
          <select
            name="diff"
            id="diff"
            className="form-select"
            value={formData.diff}
            onChange={handleChange}
            required
          >
            <option value="">--select--</option>
            <option>Easy</option>
            <option>Medium</option>
            <option>Hard</option>
          </select>
          <br />
          <label htmlFor="">Count</label>
          <select
            name="count"
            id="count"
            className="form-select"
            value={formData.count}
            onChange={handleChange}
            required
          >
            <option value="">--select--</option>
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
          </select>
          <br />
          <label htmlFor="">Type</label>
          <select
            name="type"
            id="type"
            className="form-select"
            value={formData.type}
            onChange={handleChange}
            required
          >
            <option value="">--select--</option>
            <option value="multiple_choice">MCQ</option>
            <option value="true_false">True/False</option>
            <option value="short_answer">Fill in the blanks</option>
          </select>
          <br />
          <textarea name="text" id="" className="form-control" style={{height: "300px"}}  onChange={(e) => setText(e.target.value)} required>{text}</textarea>
          <br />
          <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Generating..." : "Generate Questions"}
          </button>
          {error && <p className="text-red-500 mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
